import { registerFonts } from 'ontraccr-form-to-pdf';

const PDF_FONT_BASE_URL = '/fonts';

const fontBaseUrl = typeof window === 'undefined'
  ? PDF_FONT_BASE_URL
  : `${window.location.origin}${PDF_FONT_BASE_URL}`;

if (registerFonts) {
  registerFonts({ isWeb: true, fontBaseUrl });
}
